import { getCurrentUserRole, getCurrentUserDepartment } from './currentUser';

export const getUserRole = (): string | null => getCurrentUserRole();
export const getUserDepartment = (): string | null => getCurrentUserDepartment();
